import React, {Component} from 'react'
import { connect } from 'react-redux'

import Registry from '../../../registry/index';

import $ from 'jquery'

import './styles.scss';

class StreamingControlButton extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
        this.onMouseHover = this.onMouseHover.bind(this);
    }

    onClick(event) {
        event.preventDefault();

        var button = event.target;

        if ( button.className.indexOf('disabled') != -1 ) return false;

        this.props.dispatch({type: 'MY_VIDEO_WINDOW_TOGGLE'});
    }

    onMouseHover(event) {
        var button = event.target;

        if (button.className.indexOf("failed") != -1) return false;

        var offset = $(button).offset();

        var $streamingControlTooltip = $(this.tooltip);

        if (event.type == "mouseover") {
            $streamingControlTooltip.css({display: "inline-block", left: (offset.left-270)+"px", top: (offset.top-100)+"px"}).animate({opacity: 1}, 250);
        } else if (event.type == "mouseout") {
            $streamingControlTooltip.animate({opacity: 0}, 250, function() { this.style.display = "none"; });
        }
    }

    render() {
        let lang = Registry.get('locale');

        let {myVideoWindow, browser} = this.props;

        let mouseHoverProps = browser.desktop ? {onMouseOver: this.onMouseHover, onMouseOut: this.onMouseHover} : {};

        return (
            <div className="streaming-control-button-container">
                <a
                    className={'streaming-control ' + (myVideoWindow.shown ? '' : 'hidden')}
                    href="#"
                    onClick={this.onClick}
                    {...mouseHoverProps}
                ></a>
                <div className="streaming-control-tooltip" ref={(tooltip) => this.tooltip = tooltip} dangerouslySetInnerHTML={{__html:lang.streaming_control_tooltip}}></div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        myVideoWindow: state.myVideoWindow,
        browser: state.browser
    }
}

export default connect(mapStateToProps)(StreamingControlButton);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/StreamingControlButton/index.js